import { R } from 'core/helpers'

const getComponentName = (Component, addendum) => {
  const name = Component.displayName || Component.name || 'Component'

  return R.compact([name, addendum]).join('.')
}

export default getComponentName
